// extracted by mini-css-extract-plugin
export default {"avatar":"BotAvatar_avatar__1V39P","botIcon":"BotAvatar_botIcon__ClLuM","userAvatar":"BotAvatar_userAvatar__KGIyW"};